import { Button, Grid, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import {
  COST_SUMMARY_KINDS_OPTIONS,
  COST_SUMMARY_TYPES_OPTIONS,
} from 'pages/admin/CostDashboard/constants';
import { getIntervalFromDateRange } from 'pages/admin/CostDashboard/helper';
import { DateRange } from 'react-day-picker';
import { FormProvider, useForm } from 'react-hook-form';
import { DateRangePicker } from 'shared/components/Date';
import { FormSelectField } from 'shared/components/form';
import { CostSummaryV2Request } from 'shared/types/protoc-gen/bffbillsystem';

import { IUseGetCostSummary } from '../hooks/useGetCostSummary';

interface ICostSummaryFilter extends IUseGetCostSummary {
  setCostFilterProps: React.Dispatch<React.SetStateAction<IUseGetCostSummary>>;
}

interface CostSummaryFilterSchema extends CostSummaryV2Request {
  dateRange: DateRange;
}

const CostSummaryFilter: React.FC<ICostSummaryFilter> = ({
  area,
  endDate,
  kind,
  setCostFilterProps,
  startDate,
  type,
}) => {
  const form = useForm<CostSummaryFilterSchema>({
    defaultValues: {
      period: getIntervalFromDateRange(startDate, endDate),
      dateRange: {
        from: dayjs(startDate).toDate(),
        to: dayjs(endDate).toDate(),
      },
      kind,
      type,
      area,
    },
  });

  const handleApply = () => {
    const values = form.getValues();

    const { from, to } = values.dateRange || {};

    setCostFilterProps({
      startDate: from ? dayjs(from).format('YYYY-MM-DD') : '',
      endDate: to ? dayjs(to).format('YYYY-MM-DD') : '',
      kind: values.kind,
      type: values.type,
      area: values.area,
    });
  };

  return (
    <FormProvider {...form}>
      <form>
        <Stack spacing={3}>
          <Typography variant="h5">Filter & Analyze Cost</Typography>

          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Stack>
                <Typography>Date Range</Typography>

                <DateRangePicker
                  onChange={range => form.setValue('dateRange', range)}
                  value={form.watch('dateRange')}
                />
              </Stack>
            </Grid>

            <Grid item xs={3}>
              <Stack>
                <Typography>Kind</Typography>

                <FormSelectField
                  fieldConfig={{ name: 'kind' }}
                  items={COST_SUMMARY_KINDS_OPTIONS}
                />
              </Stack>
            </Grid>

            <Grid item xs={3}>
              <Stack>
                <Typography>Type</Typography>

                <FormSelectField
                  fieldConfig={{ name: 'type' }}
                  items={COST_SUMMARY_TYPES_OPTIONS}
                />
              </Stack>
            </Grid>

            <Grid
              item
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                p: 2,
              }}
              xs={3}
            >
              <Button onClick={handleApply}>Apply</Button>
            </Grid>
          </Grid>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default CostSummaryFilter;
